import { render, staticRenderFns } from "./AccountEdit.vue?vue&type=template&id=20b5910e&"
import script from "../account_edit.js?vue&type=script&lang=js&"
export * from "../account_edit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports